export default {
    attribute: {
        color: '#ffffff',
        fontSize: 32,
        iconfont: '',
        isFiexd: false,
    },
    cptDataForm: {
        // dataText: '[{"label":"选项1","value":"op1"},{"label":"选项2","value":"op2"},{"label":"选项3","value":"op3"}]',
        dataText: '{}',
        dataSource: 1, pollTime: -1
    },
    interaction: { multi: false },
}
